import { createApi } from "../axiosInstance";
import { createVendorApi } from "../shared/vendorApiFactory";

const api = createApi("myBusiness");

export const {
  createVendor,
  getVendors,
  getVendorById,
  updateVendor,
  deleteVendor,
  downloadVendor,
  getVendorReport,
  dayBookDownloadByVendor,
  dayBookDownload,
  getDayBookByFPOId,
} = createVendorApi(api);
